import { FC } from 'react';
import { useRouteError } from 'react-router-dom';

import { ErrorPage } from '@/shared/ui';

type Props = {
  /** Вписать экран в область содержимого каркаса вместо всего окна */
  isEmbedded?: boolean;
};

/**
 * Error-элемент маршрутизатора.
 *
 * React Router перехватывает падения рендера страниц своим встроенным механизмом раньше,
 * чем ошибка дойдёт до верхнеуровневого перехватчика вокруг всего приложения. Подключённый
 * как errorElement маршрута, компонент показывает ту же страницу восстановления
 * {@link ErrorPage} вместо дефолтного аварийного экрана React Router.
 *
 * На маршрутах страниц подключается в режиме `isEmbedded`: экран занимает только область
 * содержимого, каркас с меню разделов и верхней панелью остаётся рабочим, и пользователь
 * уходит из сбойного раздела в любой другой без перезагрузки. На маршруте самого каркаса
 * режим выключен — показывать меню в этом случае не из чего, экран занимает всё окно.
 */
export const RouteErrorElement: FC<Props> = ({ isEmbedded = false }) => {
  const error = useRouteError();
  // useRouteError может вернуть не-Error значение (например, брошенную строку) — нормализуем
  const normalizedError = error instanceof Error ? error : new Error(String(error));

  return <ErrorPage error={normalizedError} componentStack={null} isEmbedded={isEmbedded} />;
};
